import { z } from "zod";

export const REPLO_AUTH_ISSUER = "replo-auth";

export const REPLO_BEDROCK_WS_PROTOCOL = "replo.bedrock.v1";
export const REPLO_BEARER_WS_PROTOCOL_PREFIX = "replo.bearer.";

export const reploJwtSourceSchema = z
  .enum(["browser", "miniapp", "sandbox", "preview"])
  .describe("ReploJwtSource");

const baseJwtClaimsSchema = z.object({
  sub: z.uuid(),
  iss: z.literal(REPLO_AUTH_ISSUER),
  exp: z.number(),
  iat: z.number(),
  jti: z.string(),
});

const browserPrivateClaimsSchema = z.object({
  source: z.literal("browser"),
});

const miniappPrivateClaimsSchema = z.object({
  source: z.literal("miniapp"),
  projectId: z.uuid(),
  miniappId: z.string(),
});

const sandboxPrivateClaimsSchema = z.object({
  source: z.literal("sandbox"),
  projectId: z.uuid(),
  sandboxId: z.string(),
});

const previewPrivateClaimsSchema = z.object({
  source: z.literal("preview"),
  sandboxId: z.string(),
  port: z.number().int().positive(),
});

// NOTE (Max, 2026-05-26): Replo-specific per-source private claims that a
// signer must supply when minting a Replo JWT.
export const reploJwtPrivateClaimsSchema = z
  .discriminatedUnion("source", [
    browserPrivateClaimsSchema,
    miniappPrivateClaimsSchema,
    sandboxPrivateClaimsSchema,
    previewPrivateClaimsSchema,
  ])
  .describe("ReploJwtPrivateClaims");

// NOTE (Max, 2026-05-26): The full JWT payload a verifier sees (when verifying a Replo JWT). This payload is
// built by merging each private-claims arm with `baseJwtClaimsSchema`.
export const reploJwtPayloadSchema = z
  .discriminatedUnion("source", [
    browserPrivateClaimsSchema.extend(baseJwtClaimsSchema.shape),
    miniappPrivateClaimsSchema.extend(baseJwtClaimsSchema.shape),
    sandboxPrivateClaimsSchema.extend(baseJwtClaimsSchema.shape),
    previewPrivateClaimsSchema.extend(baseJwtClaimsSchema.shape),
  ])
  .describe("ReploJwtPayload");
